module.exports = __webpack_public_path__ + "static/media/frankie.1551ea2c.png";